<template>
  <div v-if="isLoading">Loading</div>
  <div v-else-if="isError">Error</div>
  <div v-else class="max-w-[500px] w-full">
    <div class="text-neutral-50 font-bold text-base mb-4">General</div>
    <SettingsForm :workspace="workspace" />
  </div>
</template>

<script setup>
import { useWorkspace } from '@/queries/composables.js';
import SettingsForm from './components/SettingsForm.vue';

const { isLoading, data: workspace, isError } = useWorkspace();
</script>
